const gql = String.raw
import * as SEO from './seo'
import * as COMMON from './common'
import { SITENAME, PROJECT_PARENT_CATEGORY_ID } from '../../utils/siteConfig'

// For Preview Pages, fetch projects by their slugs
export const PROJECTS_ACF_BY_SLUG = gql`
  query GetProjectFieldsById($id: ID!) {
    project(idType: SLUG, id: $id) {
      title
      slug
      SingleProjectFields {
        location {
          ... on Location {
            id
            locationsFields {
              location {
                cityLocation
                stateShortname
              }
            }
          }
        }

        headerProjectSize 
        headerOwner        

        headerDetails {
          detail
          fieldGroupName
          title
        }
        headerImage {
          ${COMMON.IMAGE_FIELDS}
        }
        contentBuilder {
          ... on Project_Singleprojectfields_ContentBuilder_ContentText {
            fieldGroupName
            title
            text
          }

          ... on Project_Singleprojectfields_ContentBuilder_Videoembed {
            fieldGroupName
            videoUrl
            videoPoster {
              ${COMMON.IMAGE_FIELDS}
            }
          }

          ... on Project_Singleprojectfields_ContentBuilder_ContentMediaText {
            description
            fieldGroupName
            headline
            imageAlignment
            title
            imageCaption
            image {
              ${COMMON.IMAGE_FIELDS}
            }
          }
          ... on Project_Singleprojectfields_ContentBuilder_ContentImageFull {
            fieldGroupName
            variant
            image {
              ${COMMON.IMAGE_FIELDS}
            }
          }
          ... on Project_Singleprojectfields_ContentBuilder_ContentTwoImages {
            fieldGroupName
            imageLeft {
              ${COMMON.IMAGE_FIELDS}
            }
            imageRight {
              ${COMMON.IMAGE_FIELDS}
            }
            captionLeft
            captionRight
          }
          ... on Project_Singleprojectfields_ContentBuilder_ImageSlider {
            fieldGroupName
            items {
              caption
              fieldGroupName
              image {
                ${COMMON.IMAGE_FIELDS}
              }
            }
          }

          ... on Project_Singleprojectfields_ContentBuilder_Awards {
            fieldGroupName
            items {
              fieldGroupName
              date: year
              description: title
              externalUrl
              image {
                ${COMMON.IMAGE_FIELDS}
              }
            }
          }
        }
      }

      ${SEO.SEO_CONFIG}
    }
  }
`

export const ALL_PROJECTS = gql`
  query AllProjects {
    projects(where: {taxQuery: {taxArray: {field: SLUG, includeChildren: true, taxonomy: PROJECTCATEGORY, terms: "${SITENAME}"}}, orderby: {field: MENU_ORDER, order: ASC}}, first: 9999) {
      nodes {
        title
        id
        slug
        uri
  
        SingleProjectFields {
          location {
            ... on Location {
              id
              locationsFields {
                location {
                  cityLocation
                  stateShortname
                }
              }
            }
          }          

          headerProjectSize 
          headerOwner
          headerLeedCertification

          headerRegionalOffice {
            ... on Location {
              locationsFields {
                location {
                  cityLocation
                  state
                  stateShortname
                }
              }
            }
          }          

          headerDetails {
            detail
            fieldGroupName
            title
          }
          headerImage {
            ${COMMON.IMAGE_FIELDS}
          }
          contentBuilder {
            ... on Project_Singleprojectfields_ContentBuilder_ContentText {
              fieldGroupName
              title
              text
            }

            ... on Project_Singleprojectfields_ContentBuilder_Videoembed {
              fieldGroupName
              videoUrl
              videoPoster {
                ${COMMON.IMAGE_FIELDS}
              }
            }            

            ... on Project_Singleprojectfields_ContentBuilder_ContentMediaText {
              description
              fieldGroupName
              headline
              imageAlignment
              title
              imageCaption
              image {
                ${COMMON.IMAGE_FIELDS}
              }
            }
            ... on Project_Singleprojectfields_ContentBuilder_ContentImageFull {
              fieldGroupName
              variant
              image {
                ${COMMON.IMAGE_FIELDS}
              }
            }
            ... on Project_Singleprojectfields_ContentBuilder_ContentTwoImages {
              fieldGroupName
              imageLeft {
                ${COMMON.IMAGE_FIELDS}
              }
              imageRight {
                ${COMMON.IMAGE_FIELDS}
              }
              captionLeft
              captionRight
            }
            ... on Project_Singleprojectfields_ContentBuilder_ImageSlider {
              fieldGroupName
              items {
                caption
                fieldGroupName
                image {
                  ${COMMON.IMAGE_FIELDS}
                }
              }
            }

            ... on Project_Singleprojectfields_ContentBuilder_Awards {
              fieldGroupName
              items {
                fieldGroupName
                date: year
                description: title
                externalUrl
                image {
                  ${COMMON.IMAGE_FIELDS}
                }
              }
            }            
          }
        }
  
        terms(where: {parent: ${PROJECT_PARENT_CATEGORY_ID}}) {
          nodes {
            slug
          }
        }

        ${SEO.SEO_CONFIG}        
      }
    }
  }
`
